import Image from "next/image";

export default function SingleBanner({ imageUrl }) {
    return (
        <>
            {
                imageUrl
                    ? <section className="dealership-hero position-relative overflow-hidden">
                        <div className="dl-hero-single">
                            <div className="at_hero_slider">
                                <div className="at-hero-banner">
                                    <Image
                                        src={imageUrl}
                                        alt="banner"
                                        width={1440}
                                        height={350}
                                        sizes="100vw"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover'
                                        }} />
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
            }
        </>
    );
}